import { handleActions } from 'redux-actions';
import { createSelector } from '@reduxjs/toolkit';
import {
  LOAD_EVACUATIONS_LIST,
  CREATE_EVACUATIONS,
  EDIT_EVACUATIONS_BY_ID,
  LOAD_EVACUATIONS_BY_ID,
  DELETE_EVACUATIONS,
} from './actions';
import { EVACUATIONS_MODULE } from '../../configs/moduleNames';
import {
  createLoadListReducerWithBegin,
  createOperationStateReducer,
  updateLoadParameterReducer,
} from '../../utils/getCrudConfig';

const initialState = {
  evacuationsListMeta: {},
  loadingEvacuationsList: false,
  evacuationsList: [],
  loadingCurrentEvacuations: false,
  currentEvacuations: {},
  loadingCreateEvacuations: false,
  loadingEditEvacuationsById: false,
  loadingDeleteEvacuations: false,
};

const reducer = handleActions({
  ...createLoadListReducerWithBegin(EVACUATIONS_MODULE + LOAD_EVACUATIONS_LIST, 'evacuationsList', 'loadingEvacuationsList'),
  ...updateLoadParameterReducer(EVACUATIONS_MODULE + LOAD_EVACUATIONS_BY_ID, 'currentEvacuations', 'loadingCurrentEvacuations', {}),
  ...createOperationStateReducer(EVACUATIONS_MODULE + CREATE_EVACUATIONS, 'loadingCreateEvacuations'),
  ...createOperationStateReducer(EVACUATIONS_MODULE + EDIT_EVACUATIONS_BY_ID, 'loadingEditEvacuationsById'),
  ...createOperationStateReducer(EVACUATIONS_MODULE + DELETE_EVACUATIONS, 'loadingDeleteEvacuations'),
}, initialState);

export default reducer;

export const getEvacuationsData = createSelector(
  [state => state[EVACUATIONS_MODULE]],
  state => {
    const {
      evacuationsListMeta,
      loadingEvacuationsList,
      evacuationsList,
      loadingCurrentEvacuations,
      currentEvacuations,
      loadingCreateEvacuations,
      loadingEditEvacuationsById,
      loadingDeleteEvacuations,
    } = state;
    return {
      evacuationsListMeta,
      loadingEvacuationsList,
      evacuationsList,
      loadingCurrentEvacuations,
      currentEvacuations,
      loadingCreateEvacuations,
      loadingEditEvacuationsById,
      loadingDeleteEvacuations,
    };
  },
);
